import { Component, OnInit } from '@angular/core';
import { Route } from '../../interfaces/route';
import { SystemWideService } from '../../services/system-wide.service';

@Component({
  selector: 'app-system-wide-message',
  templateUrl: './system-wide-message.component.html',
  styleUrls: ['./system-wide-message.component.css']
})
export class SystemWideMessageComponent implements OnInit {
  public statuses: Route[] = [];
  public active: boolean = false;
  public hidden: string;
  constructor(private systemWideService: SystemWideService) { }

  ngOnInit(): void {
    this.getRoute();
    this.hidden = localStorage.getItem("hide-system-message");
  }

  getRoute(): void {
    this.systemWideService.get()
        .subscribe(statuses => {
          this.statuses = statuses;
          console.log(this.statuses[0]);
          if(this.statuses[0].alert != ""){
            this.active = true;
          }

        });
  }

  onClose(): void {
    localStorage.setItem("hide-system-message", "true");
    this.ngOnInit();
  }

  onOpen(): void {
    localStorage.setItem("hide-system-message", "false");
    this.ngOnInit();
  }

}
